<p class="loginHeadingText text-start pt-1">AGENCY QUESTIONS</p>
<!-- <div class="row mb-2">
    <div class="col-md-3">
        <span class="text-blue">SETUP AT</span>
    </div>
    <div class="col-md-9">
        <span>
            <input type="radio" name="radiolist"
            [checked]="isStoreLevel"/>
            Store Level Only
        </span>
        <span>
            <input type="radio" name="radiolist"
            [checked]="isStoreAndProductLevel"/>
        Store & Product Level
        </span>      
    </div>
</div> -->
<div class="row">
    <div class="col-md-2">
        <label>QUESTIONS</label>
    </div>
    <div class="col-md-10 ps-0">
        <table class="table datatable border-x-0 mb-4">
            <tbody>
                <tr class="subheaderrr">
                    <th width="1%"></th>
                    <th width="45%"> QUESTION </th>
                    <th width="1%" class="border-end-0"></th>
                </tr>
        
                <ng-container *ngFor="let row of agencyQuestions; let i = index">
        
                    <tr>
                    
                        <td [ngClass]="parentColAutoComplete">
                            <ng-container *ngIf="row.isManuallyAddedNewAgencyQuestion; else addnewagencyquestion">
                                <img src="assets/images/plus_icon.svg" alt="" (click)="addAgencyQuestion()">
                                </ng-container>
                                <ng-template #addnewagencyquestion>
        
                                </ng-template>
                            </td>
                            <td [ngClass]="parentCol">
                                    <input class="form-control"  
                                    type="text" [(ngModel)]="row.questionText" placeholder="Add Question">                           
                                </td>                       
                        <td [ngClass]="parentCol">
                            <img src="assets/images/close_mark.svg" alt="" (click)="removeAgencyQuestion(i)">
                        </td>
                    </tr>          
                   
        
                </ng-container>
                
        
            </tbody>
        </table>
    </div>
</div>

<br/>
